import { FiledFilesProvider } from "../choices/FiledFiles";
import { AddToChatCard } from "./AddToChatCard";
import { AgentComposer } from "./AgentComposer";
import { AgentThread } from "./AgentThread";
import { NoticeProvider } from "./notice";

/**
 * The whole chat for one view: thread, composer and drop area. Mount it inside an AgentRuntime
 * (the lip card, /assistant); the parts are exported too.
 */
export function AgentChat({ className }: { className?: string }) {
  return (
    <NoticeProvider>
      <FiledFilesProvider>
        <AddToChatCard className={className}>
          <AgentThread>
            <AgentComposer />
          </AgentThread>
        </AddToChatCard>
      </FiledFilesProvider>
    </NoticeProvider>
  );
}
